import React, { useEffect, useRef } from 'react';

const SubmitSuccessContent = ({ isSoftTime, areMcqQuestions = false }) => {
  const submitSuccessRef = useRef(null);

  useEffect(() => {
    submitSuccessRef.current && submitSuccessRef.current.focus();
  }, []);

  const hardTimeContent = (
    <span ref={submitSuccessRef}>
      You have successfully submitted your exam.
      <br /> <br /> It is now safe to exit the browser.
    </span>
  );
  const softTimeContent = (
    <span ref={submitSuccessRef}>
      You have successfully submitted your assessment.
      {areMcqQuestions
        ? ' It may take a few minutes for your multiple-choice question results to become available.'
        : ''}
    </span>
  );

  return (
    <div
      className="SubmitConfirmationPopover--success leading-normal"
      aria-live="polite"
    >
      {isSoftTime ? softTimeContent : hardTimeContent}
    </div>
  );
};

export default SubmitSuccessContent;
